import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import { toast } from 'react-toastify';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import logo from '../../images/gattomioNero.png';

// Redux actions per carrello backend
import {
  loadCart,
  updateCartQuantity,
  removeFromCart,
  clearCartAction,
} from "../../store/actions/cartActions";

const CartPage = () => {
  const dispatch = useDispatch();
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  // Redux state - usa cartAPI (backend) invece di cartList (locale)
  const cart = useSelector(state => state.cartAPI);
  const { items, loading, error } = cart;

  // Calcola totale dagli items (stessa fonte di prezzo usata nella riga prodotto)
  const total = items.reduce((sum, item) => {
    const price = parseFloat(item.product?.price || item.price_snapshot || 0);
    return sum + price * item.quantity;
  }, 0);

  // Local state per operazioni in corso
  const [updatingItems, setUpdatingItems] = useState({});

  // Load cart al mount
  useEffect(() => {
    dispatch(loadCart()).catch(err => {
      console.error('Errore caricamento carrello:', err);
      toast.error('Impossibile caricare il carrello');
    });
  }, [dispatch]);

  /**
   * Incrementa quantità
   */
  const handleIncrementQuantity = async (item) => {
    try {
      setUpdatingItems(prev => ({ ...prev, [item.id]: true }));
      await dispatch(updateCartQuantity(item.id, item.quantity + 1));
      toast.success('Quantità aggiornata');
    } catch (err) {
      console.error('Errore incremento:', err);
      toast.error('Impossibile aggiornare la quantità');
    } finally {
      setUpdatingItems(prev => ({ ...prev, [item.id]: false }));
    }
  };

  /**
   * Decrementa quantità
   */
  const handleDecrementQuantity = async (item) => {
    if (item.quantity <= 1) {
      toast.warning('Quantità minima: 1. Usa "Rimuovi" per eliminare il prodotto.');
      return;
    }

    try {
      setUpdatingItems(prev => ({ ...prev, [item.id]: true }));
      await dispatch(updateCartQuantity(item.id, item.quantity - 1));
      toast.success('Quantità aggiornata');
    } catch (err) {
      console.error('Errore decremento:', err);
      toast.error('Impossibile aggiornare la quantità');
    } finally {
      setUpdatingItems(prev => ({ ...prev, [item.id]: false }));
    }
  };

  /**
   * Rimuovi item dal carrello
   */
  const handleRemoveItem = async (itemId) => {
    if (!window.confirm('Vuoi rimuovere questo prodotto dal carrello?')) {
      return;
    }

    try {
      await dispatch(removeFromCart(itemId));
      toast.success('Prodotto rimosso dal carrello');
    } catch (err) {
      console.error('Errore rimozione:', err);
      toast.error('Impossibile rimuovere il prodotto');
    }
  };

  /**
   * Svuota carrello
   */
  const handleClearCart = async () => {
    if (!window.confirm('Vuoi svuotare completamente il carrello?')) {
      return;
    }

    try {
      await dispatch(clearCartAction());
      toast.success('Carrello svuotato');
    } catch (err) {
      console.error('Errore svuotamento carrello:', err);
      toast.error('Impossibile svuotare il carrello');
    }
  };

  /**
   * Calcola prezzo singolo item (quantity * price)
   */
  const getItemTotal = (item) => {
    const price = item.product?.price || item.price_snapshot || 0;
    return (price * item.quantity).toFixed(2);
  };

  // Loading state
  if (loading && !items.length) {
    return (
      <Fragment>
        <Navbar hclass={'wpo-site-header'} Logo={logo} />
        <PageTitle pageTitle={"Cart"} pagesub={"Cart"} />
        <div className="cart-area section-padding">
          <div className="container text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Caricamento...</span>
            </div>
            <p className="mt-3">Caricamento carrello...</p>
          </div>
        </div>
        <Footer />
        <Scrollbar />
      </Fragment>
    );
  }

  // Error state
  if (error && !items.length) {
    return (
      <Fragment>
        <Navbar hclass={'wpo-site-header'} Logo={logo} />
        <PageTitle pageTitle={"Cart"} pagesub={"Cart"} />
        <div className="cart-area section-padding">
          <div className="container">
            <div className="alert alert-danger" role="alert">
              <h4 className="alert-heading">Errore!</h4>
              <p>{error}</p>
              <hr />
              <button
                className="btn btn-primary"
                onClick={() => dispatch(loadCart())}
              >
                Riprova
              </button>
            </div>
          </div>
        </div>
        <Footer />
        <Scrollbar />
      </Fragment>
    );
  }

  // Empty cart state
  if (!items || items.length === 0) {
    return (
      <Fragment>
        <Navbar hclass={'wpo-site-header'} Logo={logo} />
        <PageTitle pageTitle={"Cart"} pagesub={"Cart"} />
        <div className="cart-area section-padding">
          <div className="container text-center py-5">
            <div className="empty-cart-message">
              <i className="fi flaticon-shopping-cart" style={{ fontSize: '80px', color: '#ccc' }}></i>
              <h3 className="mt-4">Il tuo carrello è vuoto</h3>
              <p className="text-muted">Aggiungi prodotti dal catalogo per iniziare!</p>
              <Link
                onClick={ClickHandler}
                className="theme-btn mt-4"
                to="/shop"
              >
                Vai allo Shop
              </Link>
            </div>
          </div>
        </div>
        <Footer />
        <Scrollbar />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Navbar hclass={'wpo-site-header'} Logo={logo} />
      <PageTitle pageTitle={"Cart"} pagesub={"Cart"} />
      <div className="cart-area section-padding">
        <div className="container">
          <div className="form">
            <div className="cart-wrapper">
              <div className="row">
                <div className="col-12">
                  <form action="cart">
                    <table className="table-responsive cart-wrap">
                      <thead>
                        <tr>
                          <th className="images images-b">Immagine</th>
                          <th className="product-2">Prodotto</th>
                          <th className="pr">Quantità</th>
                          <th className="ptice">Prezzo</th>
                          <th className="stock">Totale</th>
                          <th className="remove remove-b">Azioni</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.map((item) => {
                          const product = item.product || {};
                          const productName = product.name || 'Prodotto';
                          const imagePath = product.proImg || product.images?.[0]?.image_path;
                          const productImage = imagePath ? `${process.env.REACT_APP_PANEL_URL}/storage/${imagePath}` : '/images/placeholder.jpg';
                          const productPrice = parseFloat(product.price || item.price_snapshot || 0);

                          return (
                            <tr key={item.id}>
                              <td className="images">
                                <img
                                  src={productImage}
                                  alt={productName}
                                  style={{ maxWidth: '80px', height: 'auto' }}
                                  onError={(e) => {
                                    e.target.src = '/images/placeholder.jpg';
                                  }}
                                />
                              </td>
                              <td className="product">
                                <ul>
                                  <li className="first-cart">{productName}</li>
                                  {product.brand && <li>Brand: {product.brand}</li>}
                                  {product.sku && <li>SKU: {product.sku}</li>}
                                  {product.category && <li>Categoria: {product.category}</li>}
                                </ul>
                              </td>
                              <td className="stock">
                                <div className="pro-single-btn">
                                  <Grid className="quantity cart-plus-minus">
                                    <span
                                      className={`dec qtybutton ${updatingItems[item.id] || item.quantity <= 1 ? 'disabled' : ''}`}
                                      onClick={() => !updatingItems[item.id] && handleDecrementQuantity(item)}
                                      style={{
                                        cursor: updatingItems[item.id] || item.quantity <= 1 ? 'not-allowed' : 'pointer',
                                        opacity: updatingItems[item.id] || item.quantity <= 1 ? 0.5 : 1
                                      }}
                                    >
                                      -
                                    </span>
                                    <input
                                      value={item.quantity || 0}
                                      type="text"
                                      readOnly
                                    />
                                    <span
                                      className={`inc qtybutton ${updatingItems[item.id] ? 'disabled' : ''}`}
                                      onClick={() => !updatingItems[item.id] && handleIncrementQuantity(item)}
                                      style={{
                                        cursor: updatingItems[item.id] ? 'not-allowed' : 'pointer',
                                        opacity: updatingItems[item.id] ? 0.5 : 1
                                      }}
                                    >
                                      +
                                    </span>
                                  </Grid>
                                  {updatingItems[item.id] && (
                                    <div className="text-center mt-1">
                                      <small className="text-muted">Aggiornamento...</small>
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td className="ptice">€{productPrice.toFixed(2)}</td>
                              <td className="stock">€{getItemTotal(item)}</td>
                              <td className="action">
                                <ul>
                                  <li
                                    className="w-btn"
                                    onClick={() => handleRemoveItem(item.id)}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <i className="fi ti-trash"></i>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </form>
                  <div className="submit-btn-area">
                    <ul>
                      <li>
                        <Link
                          onClick={ClickHandler}
                          className="theme-btn"
                          to="/shop"
                        >
                          Continua lo shopping
                        </Link>
                      </li>
                      <li>
                        <button
                          type="button"
                          onClick={handleClearCart}
                          className="theme-btn"
                          style={{ background: '#dc3545' }}
                        >
                          Svuota Carrello
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="cart-product-list">
                    <ul>
                      <li>
                        Totale prodotti<span>( {items.reduce((sum, item) => sum + item.quantity, 0)} )</span>
                      </li>
                      <li>
                        Sub Totale<span>€{total ? total.toFixed(2) : '0.00'}</span>
                      </li>
                      <li>
                        IVA (22%)<span>€{(total * 0.22).toFixed(2)}</span>
                      </li>
                      <li>
                        Spedizione<span>Gratis</span>
                      </li>
                      <li className="cart-b">
                        Totale<span>€{(total * 1.22).toFixed(2)}</span>
                      </li>
                    </ul>
                  </div>
                  <div className="submit-btn-area">
                    <ul>
                      <li>
                        <Link
                          onClick={ClickHandler}
                          className="theme-btn"
                          to="/checkout"
                        >
                          Procedi al Checkout
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default CartPage;
